export const createSlickChevron = (direction: 'prev' | 'next', ariaLabel?: string) => {
    const isLeft = direction === 'prev';
    const points = isLeft ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    const defaultLabel = isLeft ? 'poprzednie' : 'następne';
    
    return `<button type="button" class="arrow arrow-${direction}" aria-label="${ariaLabel || defaultLabel}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="${points}"></polyline></svg></button>`;
};
export const createSlickChevron = (direction: 'prev' | 'next', ariaLabel?: string) => {
    const isLeft = direction === 'prev';
    const points = isLeft ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    const defaultLabel = isLeft ? 'poprzednie' : 'następne';
    
    return `<button type="button" class="arrow arrow-${direction}" aria-label="${ariaLabel || defaultLabel}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="${points}"></polyline></svg></button>`;
};
